import { create } from "zustand";

type AppState = {
  autoSwitch: boolean;
  setAutoSwitch: (autoSwitch: boolean) => void;
};

export const useAppStore = create<AppState>((set) => ({
  autoSwitch: false,
  setAutoSwitch: (autoSwitch) => set({ autoSwitch }),
}));
